import React, { memo, useRef, useCallback, useEffect, useState } from "react";
import SearchInput from "./searchInput";
import SearchResults from "./searchResults";
import _ from "lodash";
import Icon from "app/assets/icon/icon";

const Search = memo(
  ({ open, setOpen, mobileonclick, searchVal, setSearchVal }) => {
    const [tmpSearch, setTmpSearch] = useState("");
    const ref = useRef(null);
    const onClickOutside = useCallback((e) => {
      if (!ref.current?.contains(e.target)) setOpen(false);
    }, []);
    useEffect(() => {
      document.addEventListener("click", onClickOutside);
      return () => {
        document.removeEventListener("click", onClickOutside);
      };
    }, []);

    return (
      <div
        fluid
        id={`search-container`}
        className={`${open ? "show" : "hide"}`}
        ref={ref}
      >
        <SearchInput
          setOpen={setOpen}
          searchVal={searchVal}
          setSearchVal={setSearchVal}
          setDisplaySearch={setOpen}
          tmpSearch={tmpSearch}
          setTmpSearch={setTmpSearch}
        />
        <SearchResults
          mobileonclick={mobileonclick}
          tmpSearch={tmpSearch}
          setDisplaySearch={setOpen}
        />
        <div className="close-search-desktop">
          <Icon
            icon={"closeSearch"}
            onClick={(e) => {
              e.preventDefault();
              setOpen(false);
            }}
          />
        </div>
      </div>
    );
  },
  (prevProps, nextProps) => {
    if (_.isEqual(prevProps, nextProps)) {
      return true;
    }

    return false;
  }
);

export default Search;
